import { WorkoutMovement } from 'types';
import { MovementTypeEnum } from 'types/enums';

interface SectionLike {
  movements?: ReadonlyArray<{
    workoutMovement?: { movementType?: WorkoutMovement['movementType']; deletedAt?: string | null } | null;
  }>;
}

export type SectionMode = 'per_movement' | 'section_level';

/**
 * Section-level when the lone movement's backing WorkoutMovement is not a plain movement,
 * matching the backend; anything else is per-movement.
 */
export const inferSectionMode = (section: SectionLike): SectionMode => {
  const movements = section.movements ?? [];
  if (movements.length !== 1) return 'per_movement';
  const kind = movements[0].workoutMovement?.movementType;
  return kind === MovementTypeEnum.BENCHMARK || kind === MovementTypeEnum.SCORED_SECTION
    ? 'section_level'
    : 'per_movement';
};

/**
 * True when a section-level section's benchmark is kept (active, non-soft-deleted) — re-linked on
 * copy/assign. A soft-deleted backing row is a per-section one-off; per-movement returns false.
 */
export const isKeptBenchmarkSection = (section: SectionLike): boolean => {
  if (inferSectionMode(section) !== 'section_level') return false;
  return (section.movements ?? [])[0].workoutMovement?.deletedAt == null;
};
